
































































































































import CompanyService from "@/services/companyService";
import Component from "vue-class-component";
import Header from "@/types/app/header";
import Vue from "vue";
import ManagerHeader from "../headers/managers-header";
import { Prop, Watch } from 'vue-property-decorator';
import applyCondition from "@/utils/applyCondition";
import BaseComponent from "@/utils/baseComponent";
import VuetifySelectItems from "@/types/app/vuetifySelectItems";
import CustomerService from "@/services/customerService";
import Customer, { customerInitValue } from "@/types/customer/Customer";
import ManagerInterface from "@/types/app/manager";

@Component({})
export default class CrudManager extends BaseComponent {

    loadingManagers = false;
    managerHeaders: Header[] = ManagerHeader.header;
    managerNameFilter = '';
    @Prop() public managers!: ManagerInterface[];
    @Prop(String) public readonly companyId!: string;
    editedManager!: ManagerInterface;
    companyService = new CompanyService(this.$http);
    customerService = new CustomerService(this.$http);
    dialogManagerDelete = false;
    existsClient = 'No';
    dialogManager = false;
    editedManagerIndex = -1;
    valid = false;
    customersOthers: VuetifySelectItems[] = [];
    selectedCustomers: VuetifySelectItems[] = [];

    get formManagerTitle() {
        return 'New Manager';
    }

    async mounted() {
        await this.getCustomers();
    }

    get filteredManagers() {
        const conditions: any[] = [];
        if (this.managerNameFilter) {
            conditions.push((item: ManagerInterface) =>
                item.name?.toLowerCase().includes(this.managerNameFilter.toLowerCase())
            );
        }

        return applyCondition<ManagerInterface>(this.managers, conditions);
    }

    get likesAllCustomer() {
        return this.selectedCustomers.length === this.customersOthers.length;
    }

    get likesSomeCustomers() {
        return this.selectedCustomers.length > 0 && !this.likesAllCustomer;
    }
    get icon() {
        if (this.likesAllCustomer) return "mdi-close-box";
        if (this.likesSomeCustomers) return "mdi-minus-box";
        return "mdi-checkbox-blank-outline";
    }

    toggleSelectAll() {
        this.$nextTick(() => {
            if (this.likesAllCustomer) {
                this.selectedCustomers = [];
            } else {
                this.selectedCustomers = this.customersOthers;
            }
        });
    }

    @Watch("dialogManager")
    async getCustomers(): Promise<void> {
        this.loadingManagers = true;
        this.customersOthers = await this.customerService.getSelectManagerCustomers();
        this.loadingManagers = false;
    }


    closeManagerModal() {
        this.dialogManager = false;
        this.$nextTick(() => {
            this.selectedCustomers = [];
        })

    }

    async addManagerModal() {
        if (!this.form().validate()) {
            return false;
        }
        this.loadingManagers = true;
        try {
            const clients = this.selectedCustomers.map(x =>
                ({ email: x.email, id: x.value, clientId: x.value, name: x.name, updatedDate: '' })
            )

            const result = await this.companyService.saveCompanyManagers(this.companyId, this.selectedCustomers.map(x => x.value));
            console.log('saveResult', result);
            if (!result.hasErrors) {
                clients.forEach(element => {
                    this.managers.push(element as ManagerInterface);
                });
                this.showSuccess('Created some client user manager with successfully');

                this.closeManagerModal();
            } else
                this.showError('An error occurred when trying to save the manager. Please try again later.');



        } finally {
            this.loadingManagers = false;
        }

    }
    closeManagerDelete() {
        this.dialogManagerDelete = false
        this.$nextTick(() => {
            this.editedManagerIndex = -1
        })
    }

    async deleteManagerConfirm() {
        this.loadingManagers = true;
        try {
            const result = await this.companyService.deleteCompanyManager(this.companyId, this.editedManager.clientId);
            if (!result.hasErrors) {
                this.managers.splice(this.editedManagerIndex, 1);
                this.closeManagerDelete();
                this.showSuccess('Deleted the manager with successfully');
            } else
                this.showError('An error occurred when trying to delete the manager. Please try again later.');

        }
        finally {
            this.loadingManagers = false;
        }
    }

    deleteManagerClick(item: ManagerInterface) {
        this.editedManagerIndex = this.managers.indexOf(item)
        this.editedManager = Object.assign({}, item)
        this.dialogManagerDelete = true
    }
}

